<template>
    <component
        :is="href ? 'a' : 'button'"
        class="btn tw-justify-center tw-items-baseline tw-truncate"
        :class="classes"
        :disabled="disabled || isLoading"
        v-bind="createLinkAttributes(href)"
    >
        <span v-if="isLoading">{{ $t("genericActions.loading") }}...</span>
        <slot v-else />
    </component>
</template>

<script>
// can get replaced with ure tailwind classes later
export default {
    props: {
        buttonTypes: {
            type: Array,
            default: () => [],
        },
        isTargetBlank: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        // html attributes as usable prop
        disabled: {
            type: Boolean,
            default: false,
        },
        href: {
            type: String,
        },
    },
    computed: {
        classes() {
            return {
                "btn-primary": this.buttonTypes?.includes("primary"),
                "btn-primary btn-rounded-primary": this.type?.includes("primary-rounded"),
                "btn-default": this.buttonTypes?.includes("default"),

                "btn-raised": this.buttonTypes?.includes("raised"),
                "btn-framed": this.buttonTypes?.includes("framed"),

                "btn-xs": this.buttonTypes?.includes("size-xs"),
                "btn-sm": this.buttonTypes?.includes("size-sm"),

                "tw-inline-flex": this.buttonTypes?.includes("inline"),
                "tw-flex tw-w-full": !this.buttonTypes?.includes("inline"),

                "disabled tw-cursor-not-allowed tw-opacity-30": this.disabled || this.isLoading,
            };
        },
    },
    methods: {
        createLinkAttributes(link = false) {
            if (!link) return {};
            return {
                href: link,
                target: this.isTargetBlank ? "_blank" : undefined,
                rel: this.isTargetBlank ? "noopener noreferrer" : undefined,
            };
        },
    },
};
</script>

<style scoped>
.btn {
    margin: 0;
}

.btn i {
    vertical-align: baseline;
}
</style>
